import SeoTitleRedux from './seo_title_redux';

export default SeoTitleRedux;
